<div class="row">
  <div class="col col-12">
    <app-header />
  </div>
</div>

<div tuiCardLarge tuiSurface="elevated">
  <div class="row">
    <div class="col col-12">
      <div class="row">
        <div class="col col-12">
          <div tuiHeader>
            <h1>Patients</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <button
          [appearance]="
            areArraysEqual(dosActiviteList0(), codeActiviteService.PPC) ||
            dosActiviteList0().length === 0
              ? 'primary'
              : 'outline'
          "
          size="m"
          tuiButton
          (click)="selectPPC()"
        >
          PPC
        </button>
        <button
          [appearance]="
            areArraysEqual(
              dosActiviteList0(),
              codeActiviteService.VENTILATION
            ) || dosActiviteList0().length === 0
              ? 'primary'
              : 'outline'
          "
          size="m"
          tuiButton
          (click)="selectVentilation()"
        >
          Ventilation
        </button>
        <button
          [appearance]="
            areArraysEqual(dosActiviteList0(), codeActiviteService.O2) ||
            dosActiviteList0().length === 0
              ? 'primary'
              : 'outline'
          "
          size="m"
          tuiButton
          (click)="selectOxygenotherapie()"
        >
          Oxygénothérapie
        </button>
        <button
          [appearance]="
            areArraysEqual(
              dosActiviteList0(),
              codeActiviteService.FORFAITS_ASSOCIES_PPC
            ) || dosActiviteList0().length === 0
              ? 'primary'
              : 'outline'
          "
          size="m"
          tuiButton
          (click)="selectForfaitsAssociesPPC()"
        >
          Forfaits Associés PPC
        </button>
        <button
          [appearance]="
            areArraysEqual(
              dosActiviteList0(),
              codeActiviteService.FORFAITS_ASSOCIES_VNI
            ) || dosActiviteList0().length === 0
              ? 'primary'
              : 'outline'
          "
          size="m"
          tuiButton
          (click)="selectForfaitsAssociesVNI()"
        >
          Forfaits Associés VNI
        </button>
        <button
          [appearance]="
            areArraysEqual(dosActiviteList0(), codeActiviteService.AVF) ||
            dosActiviteList0().length === 0
              ? 'primary'
              : 'outline'
          "
          size="m"
          tuiButton
          (click)="selectAvf()"
        >
          AVF
        </button>
        <button
          [appearance]="
            areArraysEqual(dosActiviteList0(), codeActiviteService.AEROSOLS) ||
            dosActiviteList0().length === 0
              ? 'primary'
              : 'outline'
          "
          size="m"
          tuiButton
          (click)="selectAerosols()"
        >
          Aérosols
        </button>
        @if (dosActiviteList0().length != 0) {
          <button appearance="outline" size="m" tuiButton (click)="unselect()">
            Tous mes patients
          </button>
        }
      </div>
      <div class="row">
        <button
          [appearance]="btnEcheanceSelected0() == 0 ? 'primary' : 'outline'"
          class="echues"
          size="m"
          tuiButton
          (click)="selectEchues()"
        >
          Prescriptions échues
        </button>
        <button
          [appearance]="btnEcheanceSelected0() == 1 ? 'primary' : 'outline'"
          class="echues-1-mois"
          size="m"
          tuiButton
          (click)="selectEchues1mois()"
        >
          Prescriptions échues sous 1 mois
        </button>
        <button
          [appearance]="btnEcheanceSelected0() == 2 ? 'primary' : 'outline'"
          class="echues-2-mois"
          size="m"
          tuiButton
          (click)="selectEchues2mois()"
        >
          Prescriptions échues sous 2 mois
        </button>
        <button
          [appearance]="btnEcheanceSelected0() == 3 ? 'primary' : 'outline'"
          class="initiales"
          size="m"
          tuiButton
          (click)="selectInitiales()"
        >
          Prescriptions initiales à valider
        </button>
        @if (btnEcheanceSelected0() != undefined) {
          <button
            appearance="outline"
            size="m"
            tuiButton
            (click)="unselectEchues()"
            class="btn-unselect"
          >
            <tui-icon size="s" icon="@tui.x" />
          </button>
        }
      </div>
      <div class="row">
        <div class="col col-12">
          <form [formGroup]="searchForm" (ngSubmit)="onSubmitForm()">
            <tui-input formControlName="nom">
              Nom
              <input tuiTextfieldLegacy />
            </tui-input>
            <button size="m" tuiButton style="display: none">OK</button>
          </form>
          <app-patient-list
            [dosActiviteList]="dosActiviteList0()"
            [dosEcheanceMin]="dosEcheanceMin0()"
            [dosEcheanceMax]="dosEcheanceMax0()"
            [dosEcheanceInitiales]="dosEcheanceInitiales0()"
            (onChangeDePage)="changementDePage($event)"
            [nom]="nom0()"
            [page]="page0()"
          />
        </div>
      </div>
    </div>
  </div>
</div>
